import React, { useEffect, useState } from "react";

function Joke() {
  const [joke, setJoke] = useState();

  useEffect(() => {
    fetch("https://v2.jokeapi.dev/joke/Programming?type=single")
      .then((res) => res.json())
      .then((data) => {
        setJoke(data.joke);
      });
  }, []);

  return <p className="text-dark">Here I have a joke:<br/>{joke}</p>;
}

export default Joke;
